import { faCopyright } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import AudioController from "./AudioController";
const RootLayout = ({ children }) => {
  return (
    <div className="min-h-screen relative bg-[url('./static/images/ColonyNight.png')] bg-center bg-cover flex w-full">
      <div className="-z-1 absolute top-0 left-0 w-full h-full bg-cyber-bg/75 pointer-events-none"></div>
      {children}
      <div className="absolute left-1 bottom-0 z-50 opacity-50 text-white text-xs flex items-center gap-1">
        {/* <p>Copyright</p> */}
        <FontAwesomeIcon icon={faCopyright} />
        <p>BCIT Applied Research SMART</p>
      </div>

      <AudioController />
    </div>
  );
};
export default RootLayout;
